// extracted by mini-css-extract-plugin
module.exports = {"root":"index__root___2LFFL","fullWidth":"index__fullWidth___3qGDy","inverted":"index__inverted___GMGfL","inferior":"index__inferior___2Uw_z","disabled":"index__disabled___3z-GT"};